import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    tabletToken: null,
	tabletId: null,
	tabletName: null,
	isAppLoggedIn: false,
	tabletLanguage: '',
	tabletSelectedAcademy: '',
	tabletManagedAcademy: ''
	},
	plugins: [createPersistedState()],
	mutations: {
		setTabletToken (state, token) {
			state.tabletToken = token
			if(token) {
				state.isAppLoggedIn = true
			} else {
				state.isAppLoggedIn = false
			}
		},
		setTabletId (state, tabletId) {
			state.tabletId = tabletId
		},
		setTabletName (state, name) {
			state.tabletName = name
		},
		setTabletLanguage (state, value){
			state.tabletLanguage = value
		},
		setTabletSelectedAcademy (state, value){
			state.tabletSelectedAcademy = value
		},
		setTabletManagedAcademy (state, value){
			state.tabletManagedAcademy = value
		}
	},
	actions: {
		setToken ({commit}, token) {
			commit('setTabletToken', token)
		},
		setTabletId ({commit}, tabletId) {
			commit('setTabletId', tabletId)
		},
		setTabletName ({commit}, name) {
			commit('setTabletName', name)
		},
		setTabletLanguage({commit}, value){
			commit('setTabletLanguage', value)
		},
		setTabletSelectedAcademy({commit}, value){
			commit('setTabletSelectedAcademy', value)
		},
		setTabletManagedAcademy({commit}, value){
			commit('setTabletManagedAcademy', value)
		},
	}
})